import React, { useEffect, useState } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import { useParams } from "react-router-dom";
import preloadimg from "../../assets/img/preloader1.gif";
import $ from "jquery";
import { Alert, Button } from "react-bootstrap";
import { FaPrint } from "react-icons/fa";
import { Box, Fab } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import NavHeader from "../nav/NavHeader";
import SideMenu from "../nav/Sidemenu";
import ReportChatBot from "./ReportChatBot";
import Login from "../pages/Login";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { useCustomVisuals } from "../../hooks/useCustomVisuals";
import { useBookmark } from "../../hooks/useBookmark";
import { useReportTracking } from "../../hooks/useReportTracking";
import { getToken } from "../auth/authConfig";
import AppButton from "../layout/AppButton";

const PowerBiReports = () => {
  const { fetchReportData } = useCustomVisuals();
  const { fetchBookmarks, saveBookmark, deleteBookmark } = useBookmark();
  const { trackReportView } = useReportTracking();

  const [pbireports, setPbireports] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const [iserror, seterror] = useState(false);
  const [isLoaded, seteLoaded] = useState(false);
  const [PageLoading, setPageLoading] = useState(true);
  const [currentPage, setcurrentPage] = useState(0);
  const [pagename, setPageName] = useState("");
  const [pageDisplayname, setDisplyName] = useState("");
  const [open, setOpen] = useState(false);
  const [openBookmark, setopenBookmark] = useState(false);

  const [pbiPages, setPages] = useState([]);
  const { ReportID } = useParams();

  const getURl = new URL(window.location.href);
  const reportnameFetch = getURl.searchParams.get("ReportSection");
  const groupIdFromUrl = getURl.searchParams.get("groupId");
  const [Saving, setSaving] = useState(false);
  const [removing, setRemoving] = useState(false);

  const [saveBookmarkReports, setsaveBookmarkReports] = useState([]);

  const { instance } = useMsal();

  // console.log(reportnameFetch);

  const [passtoken, setpasstoken] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const fetchToken = async () => {
      try {
        const token = await getToken();
        if (token && isMounted) {
          setpasstoken(token);
        }
      } catch (error) {
        console.error("Failed to acquire token", error);
      }
    };
    fetchToken();
    return () => {
      isMounted = false;
    };
  }, [instance]);

  const viewNotificationsReply = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const notificationID = searchParams.get("notificationiD");

    if (notificationID !== null) {
      $("#NotificationsIdValues").css("display", "block");
      $("#main").css("marginRight", "400px");
      $(`#postDataid_${notificationID}`).css("display", "block");

      const element = document.getElementById(`topic_id_${notificationID}`);
      if (element) {
        element.scrollIntoView();
      } else {
        console.error(`Element with id 'topic_id_${notificationID}' not found`);
      }
    }
  };

  useEffect(() => {
    const fetchSearchByname = async () => {
      try {
        const json = await fetchReportData(ReportID);
        setPbireports(json.data);
        seterror(false);
        setIsloading(false);
        setPageLoading(false);
        const data = json.data;
        if (data.embedReport.embedToken === null) {
          seteLoaded(true);
        }
      } catch (err) {
        seterror(true);
        setPbireports(null);
        seteLoaded(false);
        setPageLoading(false);
      }
    };
    fetchSearchByname();
  }, [ReportID]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    GetBookmarkURLReports();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const GetBookmarkURLReports = async () => {
    try {
      const json = await fetchBookmarks();
      setsaveBookmarkReports(json);
    } catch (err) {
      setsaveBookmarkReports(null);
    }
  };

  if (pbireports === null) {
    console.log("Data not available");
  }

  const embeddingData = pbireports?.embedReport;
  const EmbedUrl = embeddingData?.url;
  const Embedaccess_token = embeddingData?.embedToken;
  const EmbedPBIreport_id = `${embeddingData?.reportGuid}`;
  const PowerBiReportsName = embeddingData?.name;

  // console.log(EmbedUrl)
  const report = window.report;

  function fn(e) {
    for (var i = tooltip.length; i--; ) {
      tooltip[i].style.left = e.pageX + "px";
      tooltip[i].style.top = e.pageY + "px";
    }
  }

  if (isLoaded) {
    var tooltip;
    tooltip = document.querySelectorAll(".tooltiptext");
    document.addEventListener("mousemove", fn, false);
    viewNotificationsReply();
  }

  const applyBookmarkRestore = async (activePage) => {
    try {
      const raw = sessionStorage.getItem("bookmark-restore");
      if (!raw) return;
      const { pagename: savedPage, filterJson, slicerJson } = JSON.parse(raw);
      if (activePage.name !== savedPage) return;

      // Apply page-level filters
      if (filterJson) {
        try {
          const filters = JSON.parse(filterJson);
          if (Array.isArray(filters) && filters.length > 0) {
            await activePage.setFilters(filters);
          }
        } catch (e) {
          console.warn("Could not apply bookmark filters:", e);
        }
      }

      // Apply slicer states
      if (slicerJson) {
        try {
          const slicers = JSON.parse(slicerJson);
          const visuals = await activePage.getVisuals();
          for (const slicerData of slicers) {
            const visual = visuals.find((v) => v.name === slicerData.visualName);
            if (visual && slicerData.state) {
              await visual.setSlicerState(slicerData.state);
            }
          }
        } catch (e) {
          console.warn("Could not apply bookmark slicers:", e);
        }
      }

      // Clear after applying so it doesn't re-apply on page change
      sessionStorage.removeItem("bookmark-restore");
    } catch (e) {
      console.warn("bookmark-restore error:", e);
    }
  };

  const embdData = (embeddedReport) => {
    window.report = embeddedReport;
    window.report.on("loaded", async function () {
      var reportPages = await window.report.getPages();
      // Function to apply filters

      report.getPages().then(async (pages) => {
        const indexNumber = pages.findIndex(
          (p) => p.name === `${reportnameFetch}`
        );
        const firstPage = pages[indexNumber === -1 ? 0 : indexNumber];
        const pageName = firstPage.name;
        const displayName = firstPage.displayName;
        setPageName(pageName);
        setDisplyName(displayName);

        // Apply bookmark-saved filters/slicers if navigating from a bookmark
        await applyBookmarkRestore(firstPage);
      });

      report.on("pageChanged", (event) => {
        const currentPage = event.detail.newPage;
        const pageName = currentPage.name;
        const displayName = currentPage.displayName;
        setPageName(pageName);
        setDisplyName(displayName);
      });

      report.on("dataSelected", (event) => {
        console.log("dataSelected");
      });

      window.report.getPages().then(function (pages) {
        const indexNumber = pages.findIndex(
          (p) => p.name === `${reportnameFetch}`
        );
        if (reportnameFetch !== null) {
          setcurrentPage(indexNumber + 1);
          $(`#pbiPages span:nth-child(${indexNumber + 1})`).addClass("active");
        } else {
          pages[0].setActive();
          const pageButtons = document.querySelectorAll("#pbiPages span");
          pageButtons.forEach((button) => {
            button.classList.remove("active");
          });

          // Add "active" class to the button corresponding to the first page
          const activeButton = document.querySelector(
            `#pbiPages span:first-child`
          );
          if (activeButton) {
            activeButton.classList.add("active");
          }
        }
      });

      setPages(reportPages);
      seteLoaded(true);
      trackingData();
    });
  };

  const saveReports = async () => {
    setSaving(true);
    setopenBookmark(false);

    // Capture current filters and slicers from the embedded report
    let filterJson = null;
    let slicerJson = null;

    try {
      if (window.report) {
        // Page-level filters
        const pages = await window.report.getPages();
        const activePage = pages.find((p) => p.isActive) || pages[0];

        if (activePage) {
          const filters = await activePage.getFilters();
          if (filters && filters.length > 0) {
            filterJson = JSON.stringify(filters);
          }

          // Slicer visuals
          const visuals = await activePage.getVisuals();
          const slicers = visuals.filter((v) => v.type === "slicer");
          if (slicers.length > 0) {
            const slicerStates = await Promise.all(
              slicers.map(async (s) => {
                try {
                  const state = await s.getSlicerState();
                  return { visualName: s.name, title: s.title, state };
                } catch {
                  return null;
                }
              })
            );
            const validSlicers = slicerStates.filter(Boolean);
            if (validSlicers.length > 0) {
              slicerJson = JSON.stringify(validSlicers);
            }
          }
        }
      }
    } catch (err) {
      console.warn("Could not capture filters/slicers:", err);
    }

    const data = [
      {
        reportId: parseInt(ReportID),
        pagename: `${pagename}`,
        title: `${pageDisplayname}`,
        filterJson,
        slicerJson,
      },
    ];

    saveBookmark(data)
      .then(function () {
        GetBookmarkURLReports();
        setSaving(false);
        toast.success(
          `${decodeURIComponent(pageDisplayname)} Added Successfully`,
          {
            position: toast.POSITION.BOTTOM_LEFT,
            autoClose: 6000,
          }
        );
      })
      .catch(function (error) {
        console.log(error);
        alert("Error");
        setSaving(false);
      });
  };

  const removeBookmark = () => {
    setRemoving(true);
    setOpen(false);

    deleteBookmark(parseInt(ReportID), pagename, pageDisplayname)
      .then(() => {
        setRemoving(false);
        GetBookmarkURLReports();
        toast.success(
          `${decodeURIComponent(
            pageDisplayname
          )} Bookmark Removed Successfully`,
          {
            // Set to 15sec
            position: toast.POSITION.BOTTOM_LEFT,
            autoClose: 6000,
          }
        );
      })

      .catch((error) => {
        alert("Error deleting resource:", error);
      });
  };

  const downloadReportAsPDF = async () => {
    report.print().catch((error) => {
      console.log(error);
    });
  };

  const trackingData = () => {
    trackReportView(parseInt(ReportID), parseInt(localStorage.getItem("userGroup")))
      .then(function () {
        console.log("Tracking in progress ...");
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const onreploadPage = () => {
    console.log("reload");
  };

  // console.log(currentPage);

  const activeCurrentPage = async (e) => {
    // var reportPages = await window.report.getPages();
    //         reportPages[currentPage].setActive();
    var target = e.target;
    var parent = target.parentNode;
    var index = [].indexOf.call(parent.children, target);
    // $(this).addClass("active").siblings().removeClass("active");
    // setcurrentPage(index);
    var reportPages = await window.report.getPages();
    reportPages[index].setActive();

    // console.log(target);
  };

  const getVisualsData = async () => {
    if (!window.report) return [];
    try {
      const pages   = await window.report.getPages();
      const active  = pages.find((p) => p.isActive) || pages[0];
      const visuals = await active.getVisuals();
      const results = await Promise.all(
        visuals
          .filter((v) => v.type !== "slicer" && v.type !== "image" && v.type !== "shape")
          .map(async (v) => {
            try {
              const exported = await v.exportData(0); // 0 = Summarized
              return { title: v.title || v.name, type: v.type, csv: exported.data };
            } catch {
              return null;
            }
          })
      );
      return results.filter(Boolean);
    } catch {
      return [];
    }
  };

  return (
    <div>
      <AuthenticatedTemplate>
        {PageLoading && (
          <>
            <NavHeader onclickmenu={false} />
            <SideMenu />
          </>
        )}

        {!PageLoading && (
          <>
            <NavHeader
              title={pageDisplayname}
              guid={EmbedPBIreport_id}
              reportId={ReportID}
              pageName={pagename}
              groupId={groupIdFromUrl}
              onclickmenu={Embedaccess_token !== null ? true : false}
              onreploadPage={onreploadPage}
              pageLoad={Embedaccess_token !== null ? isLoaded : false}
            />
            <SideMenu
              activeCurrentPage={(e) => activeCurrentPage(e)}
              setcurrentPage={setcurrentPage}
              id={ReportID}
              pages={pbiPages}
              name={Embedaccess_token !== null ? "PowerBINav" : ""}
              activeIndexData={currentPage}
              reportnameFetch={reportnameFetch || null}
              Embedaccess_token={Embedaccess_token}
            />
          </>
        )}
        <div id="main">
          <div style={{ height: "100%", position: "relative" }}>
            {!isLoaded && (
              <div
                style={{
                  position: "absolute",
                  background: "white",
                  left: 0,
                  right: 0,
                  top: 0,
                  bottom: 0,
                  zIndex: 9999999,
                }}
                className="pageLoading"
              >
                <div
                  style={{
                    position: "fixed",
                    background: "rgba(0,0,0,0.8)",
                    width: "100%",
                    height: "100%",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    display: "grid",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "white",
                    zIndex: "99999",
                    justifyItems: "center",
                    alignContent: "center",
                  }}
                >
                  <img width={200} src={preloadimg} alt="Loading" />
                  <span>Report is loading, please wait...</span>
                </div>
              </div>
            )}

            {!isLoading && !iserror && Embedaccess_token !== null && (
              <div style={{ position: "relative", height: "100%" }}>
                {isLoaded && (
                  <>
                    <Button
                    style={{
                      position: "absolute",
                      right: "-35px",
                      top: "-30px",
                      background: "white",
                      color: "#a3172f",
                      border: "none",
                    }}
                    onClick={downloadReportAsPDF}
                  >
                    <FaPrint />
                  </Button>

                    {saveBookmarkReports.some(
                    (item) => item.pagename === pagename
                  ) ? (
                    // Render the bookmark added button when pageName matches
                    <Box className="floatingButtonHome">
                      <Fab
                        className="floatingButton"
                        color="primary"
                        style={{ position: "fixed", right: "40px", zIndex: 0 }}
                        aria-label="add"
                        onClick={() => setOpen(!open)}
                      >
                        <BookmarkAddedIcon sx={{ color: "white" }} />
                      </Fab>
                    </Box>
                  ) : (
                    // Render the original button when pageName does not match
                    <Box className="floatingButtonHome">
                      <Fab
                        onClick={() => setopenBookmark(!openBookmark)}
                        className="floatingButton"
                        color="primary"
                        style={{ position: "fixed", right: "40px", zIndex: 0 }}
                        aria-label="add"
                      >
                        <StarBorderIcon />
                      </Fab>
                    </Box>
                  )}

                  </>
                )}

                <PowerBIEmbed
                  embedConfig={{
                    type: "report", // Supported types: report, dashboard, tile, visual, and qna.
                    id: EmbedPBIreport_id,
                    embedUrl: EmbedUrl,
                    accessToken: Embedaccess_token,
                    //pageName: 'ReportSectione5bc25aa0357c917eaaa',
                    pageName: `${
                      reportnameFetch === null ? "" : reportnameFetch
                    }`,
                    tokenType: models.TokenType.Embed, // Use models.TokenType.Aad if you're embedding for your organization.
                    permissions: models.Permissions.All,
                    viewMode: models.ViewMode.View,

                    settings: {
                      navContentPaneEnabled: false,
                      filterPaneEnabled: true,
                      persistentFiltersEnabled: true,

                      bars: {
                        actionBar: {
                          visible: true,
                        },
                        statusBar: {
                          visible: false,
                        },
                      },
                      panes: {
                        filters: {
                          expanded: false,
                          visible: true,
                        },
                      },
                    },
                  }}
                  eventHandlers={
                    new Map([
                      [
                        "loaded",
                        async function () {
                          console.log("Report loaded");
                        },
                      ],

                      ["dataSelected", function (event) {}],

                      [
                        "rendered",
                        async function () {
                          // console.log("Report rendered");
                          // var reportPages = await window.report.getPages();
                          // setPbireports(reportPages)
                        },
                      ],
                      [
                        "error",
                        function (event) {
                          // console.log(event.detail);
                        },
                      ],
                    ])
                  }
                  cssClassName={"report-style-class"}
                  getEmbeddedComponent={embdData}
                />
              </div>
            )}

            {!isLoading && Embedaccess_token === null && (
              <div className="reportView_pbi">
                <Alert variant="danger">
                  Powerbi access token is expired please check after sometime
                </Alert>
              </div>
            )}

            {iserror && <div>There is some error Please try again later </div>}

            {Saving && (
              <div
                style={{
                  position: "fixed",
                  background: "rgba(0,0,0,0.8)",
                  width: "100%",
                  height: "100%",
                  top: "0",
                  left: "0",
                  right: "0",
                  bottom: "0",
                  display: "grid",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                  zIndex: "99999",
                  justifyItems: "center",
                  alignContent: "center",
                }}
              >
                <img width={200} src={preloadimg} alt="Loading" />
                <span>Adding your bookmark...</span>
              </div>
            )}

            {removing && (
              <div
                style={{
                  position: "fixed",
                  background: "rgba(0,0,0,0.8)",
                  width: "100%",
                  height: "100%",
                  top: "0",
                  left: "0",
                  right: "0",
                  bottom: "0",
                  display: "grid",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                  zIndex: "99999",
                  justifyItems: "center",
                  alignContent: "center",
                }}
              >
                <img width={200} src={preloadimg} alt="Loading" />
                <span>Removing your bookmark...</span>
              </div>
            )}

            <Dialog
              open={open}
              onClose={() => setOpen(!open)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle
                style={{
                  background: "var(--app-ai-assistant-gradient, linear-gradient(135deg,#253978,#1a2a5e))",
                  color: "#fff",
                  fontWeight: "500",
                }}
                id="alert-dialog-title"
              >
                {"This page is already bookmarked!!"}
              </DialogTitle>
              <DialogContent style={{ marginTop: "16px" }}>
                <DialogContentText id="alert-dialog-description">
                  Do you wish to remove the bookmark?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <AppButton onClick={removeBookmark} autoFocus style={{color:"white"}}>
                  Yes
                </AppButton>

                <AppButton variant="secondary" onClick={() => setOpen(!open)}>
                  No
                </AppButton>
              </DialogActions>
            </Dialog>

            <Dialog
              open={openBookmark}
              onClose={() => setopenBookmark(!openBookmark)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle
                style={{
                  background: "var(--app-ai-assistant-gradient, linear-gradient(135deg,#253978,#1a2a5e))",
                  color: "#fff",
                  fontWeight: "500",
                }}
                id="alert-dialog-title"
              >
                {"A bookmark will be successfully established for this page"}
              </DialogTitle>
              <DialogContent style={{ marginTop: "16px" }}>
                <DialogContentText id="alert-dialog-description">
                  Please confirm to bookmark this page
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <AppButton onClick={saveReports} autoFocus style={{color:"white"}}>
                  Yes
                </AppButton>

                <AppButton variant="secondary" onClick={() => setopenBookmark(!openBookmark)}>
                  No
                </AppButton>
              </DialogActions>
            </Dialog>

            {isLoaded && (
              <ReportChatBot
                reportName={PowerBiReportsName}
                pageName={pageDisplayname}
                passtoken={passtoken}
                getVisuals={getVisualsData}
              />
            )}

            <ToastContainer />
          </div>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default PowerBiReports;
